import {FC} from 'react';
import {TERMS_DOCUMENTS} from '../../model/termsDocuments';
import {TermsDocumentIconView} from './TermsDocumentIcons';
import styles from './TermsDocumentsList.module.css';

export const TermsDocumentsList: FC = () => (
	<ul className={styles.list}>
		{TERMS_DOCUMENTS.map((document) => (
			<li key={document.id} className={styles.item}>
				<a
					className={styles.link}
					href={document.url}
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className={styles.label}>{document.label}</span>
					<span className={styles.iconWrap} aria-hidden>
						<TermsDocumentIconView name={document.icon} className={styles.icon} />
					</span>
				</a>
			</li>
		))}
	</ul>
);
